<div [class.is-ready]="isFlickityLoaded"
     class="amg-carousel__container">

  <ng-container *ngTemplateOutlet="topCarouselTemplate"></ng-container>

  <div #carouselContainer
       class="amg-carousel__content">

    <ng-content></ng-content>

    <!-- <ng-container *ngIf="items">
       <div *ngFor="let item of items; let idx = index"
            class="item">
         <ng-container *ngIf="itemTemplate">
           <ng-template
               *ngTemplateOutlet="itemTemplate; context: { data: item, index: idx }"
           ></ng-template>
         </ng-container>

         &lt;!&ndash; item template not provided &ndash;&gt;
         <ng-container *ngIf="!itemTemplate">
           {{ item | json }}
         </ng-container>
       </div>
     </ng-container>-->
  </div>

  <ng-container *ngTemplateOutlet="bottomCarouselTemplate"></ng-container>
</div>
